// extracted by mini-css-extract-plugin
export default {"btn":"login_btn__KWdbU","form-container":"login_form-container__9e0tm","forgot-password-cta":"login_forgot-password-cta__9HNgK"};